<template>
    <el-container>

        <el-row :gutter="10" class="queryfm-head">
        <el-form :inline="true" size="small" label-width="90px">
            <el-col :span="8">
            <el-form-item label="套餐名称">
                <select v-model="formQuery.pkg_id" @change="handleFilterPkg" class="fm-select-control">
                    <option v-for="item in pkg_options" :value="item.value">{{item.label}}</option>
                </select>
            </el-form-item>
            </el-col>
            <el-col :span="8">
            <el-form-item label="ICCID">
                <el-input v-model="formQuery.iccid" placeholder="ICCID卡号" style="width: 220px;"></el-input>
            </el-form-item>
            </el-col>
            <el-col :span="8">
            <el-form-item label="MSISDN">
                <el-input v-model="formQuery.msisdn" placeholder="SIM卡号" style="width: 220px;"></el-input>
            </el-form-item>
            </el-col>
            <el-col :span="8">
            <el-form-item label="状态">
                <select v-model="formQuery.status" @change="handleChangeStatusSel" class="fm-select-control">
                    <option v-for="item in status_options" :value="item.value">{{item.label}}</option>
                </select>
            </el-form-item>
            </el-col>
            <el-col :span="8">
            <el-form-item label="激活时间">
                <el-date-picker
                    v-model="activetime"
                    type="daterange"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['00:00:00', '23:59:59']"
                    style="width: 220px;">
                </el-date-picker>
            </el-form-item>
            </el-col>
            <el-col :span="8">
            <el-form-item>
                <el-button type="primary" size="small" @click="submitSearch">查询</el-button>
                <el-button type="default" size="small" @click="search">导出</el-button>
                <el-button type="default" size="small" @click="insyncCardInfo">同步数据</el-button>
            </el-form-item>
            </el-col>
        </el-form>
        </el-row>

        <el-row :gutter="10" class="queryfm-head">
            <el-col :span="2">
                <el-button type="default" icon="el-icon-s-fold" @click="collapseHTree" size="mini"></el-button>
            </el-col>
            <el-col :span="2">
                <div class="static-total-records">总数：{{ pagging.records_total }}</div>
            </el-col>
            <el-col :span="20">
                &nbsp;
            </el-col>
        </el-row>

        <div class="sanmuui-body-container">
            <div class="sanmuui-body-left" v-show="displayHTreeVisible">
              <div class="tree-divBox">
                  <el-tree 
                      :data="holdTreeData" 
                      :props="defaultProps" 
                      default-expand-all 
                      ref="getTreeInstance" 
                  @node-click="handleNodeClick"></el-tree>
              </div>
            </div>
            <div class="sanmuui-body-right">
                <el-table
                id="tbGridView"
                ref="getTableInstance"
                :data="tableData"
                :height="tableViewHeight"
                v-loading="loadingTableData"
                @selection-change="handleSelectionChange"
                @row-click="openCardDetailDrawer"
                size="small"
                border
                style="width: 100%">
                    <el-table-column
                    type="selection"
                    width="55">
                    </el-table-column>
                    <el-table-column
                    prop="iccid"
                    label="ICCID号"
                    width="160">
                    </el-table-column>
                    <el-table-column
                    prop="sim"
                    label="SIM卡/MSISDN"
                    width="150">
                    </el-table-column>
                    <el-table-column
                    prop="package_name"
                    label="套餐"
                    width="100">
                    </el-table-column>
                    <el-table-column
                    prop="hold_name"
                    label="所属用户"
                    width="150">
                    </el-table-column>
                    <el-table-column
                    prop="status_text"
                    label="状态"
                    width="80">
                    </el-table-column>
                    <el-table-column
                    prop="amount_usage"
                    label="总流量(MB)"
                    width="120">
                    </el-table-column>
                    <el-table-column
                    prop="month_usage"
                    label="当月流量(MB)"
                    width="120">
                    </el-table-column>
                    <el-table-column
                    prop="flowleft_time"
                    label="同步时间"
                    width="150">
                    </el-table-column>
                    <el-table-column
                    prop="apn"
                    label="APN"
                    width="100">
                    </el-table-column>
                    <el-table-column
                    prop="main_ip"
                    label="IP"
                    width="150">
                    </el-table-column>
                    <el-table-column
                        prop="operator"
                        fixed="right"
                        label="操作"
                        width="100">
                        <template slot-scope="scope">
                            <el-button
                            size="mini"
                            type="danger"
                            @click="removeCard(scope.row.sim_id)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <div class="dv-pagging-container">
                    <el-pagination
                    background
                    layout="prev, pager, next"
                    @current-change="handleCurrentChange"
                    :page-size="pagging.pager_size"
                    :pager-count="pagging.pager_count"
                    :total="pagging.records_total"
                    :current-page="pagging.current_page">
                    </el-pagination>
                </div>

            </div>
        </div>

        <el-drawer
        title="卡详情"
        :visible.sync="drawer"
        :with-header="false"
        :direction="direction">
            <div class="dr-container">
                <el-tabs v-model="drActiveName" @tab-click="handleDrTabClick">
                    <el-tab-pane label="卡详情" name="detail">
                        <div class="dr-card-detail">
                            <el-row>
                                <el-col :span="12"><div class="dr-card-label">ICCID号</div></el-col>
                                <el-col :span="12"><div class="dr-card-label">套餐</div></el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">{{this.simCardDetailForm.iccid}}</el-col>
                                <el-col :span="12">{{this.simCardDetailForm.package}}</el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12"><div class="dr-card-label">Msisdn号</div></el-col>
                                <el-col :span="12"><div class="dr-card-label">状态</div></el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">{{this.simCardDetailForm.sim}}</el-col>
                                <el-col :span="12">{{this.simCardDetailForm.status}}</el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12"><div class="dr-card-label">激活时间</div></el-col>
                                <el-col :span="12"><div class="dr-card-label">到期时间</div></el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">{{this.simCardDetailForm.active_time}}</el-col>
                                <el-col :span="12">{{this.simCardDetailForm.expired_time}}</el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12"><div class="dr-card-label">静默期(月)</div></el-col>
                                <el-col :span="12"><div class="dr-card-label">IP</div></el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">{{this.simCardDetailForm.quiet_period}}</el-col>
                                <el-col :span="12">{{this.simCardDetailForm.main_ip}}</el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12"><div class="dr-card-label">APN</div></el-col>
                                <el-col :span="12"><div class="dr-card-label">机卡绑定</div></el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">{{this.simCardDetailForm.apn}}</el-col>
                                <el-col :span="12">{{this.simCardDetailForm.imeiBindStatus}}</el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12"><div class="dr-card-label">国家/地区</div></el-col>
                                <el-col :span="12"><div class="dr-card-label">当地运营商</div></el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">{{this.simCardDetailForm.country}}</el-col>
                                <el-col :span="12">{{this.simCardDetailForm.operator_locate}}</el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12"><div class="dr-card-label">当月流量</div></el-col>
                                <el-col :span="12"><div class="dr-card-label"></div></el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                <div ref="pieChart" style="width: 400px; height: 300px;"></div>
                                </el-col>
                            </el-row>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="近3个月使用流量" name="last3month_usage">
                        <el-table
                            :data="monthlyUsageTable"
                            border
                            style="width: 100%">
                            <el-table-column
                                prop="iccid"
                                label="ICCID"
                                width="180">
                            </el-table-column>
                            <el-table-column
                                prop="usedDataMonth"
                                label="套餐内用量(MB)"
                                width="130">
                            </el-table-column>
                            <el-table-column
                                prop="outPackageUsage"
                                label="套餐外用量(MB)"
                                width="130">
                            </el-table-column>
                            <el-table-column
                                prop="month"
                                label="月份"
                                width="80">
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane label="套餐计划" name="session">
                        <el-table
                            :data="sessionUsageTable"
                            border
                            style="width: 100%">
                            <el-table-column
                                prop="devId"
                                label="套餐名称"
                                width="150">
                            </el-table-column>
                            <el-table-column
                                prop="iccid"
                                label="状态"
                                width="150">
                            </el-table-column>
                            <el-table-column
                                prop="currUsage"
                                label="类型"
                                width="100">
                            </el-table-column>
                            <el-table-column
                                prop="currUsage"
                                label="总流量"
                                width="100">
                            </el-table-column>
                            <el-table-column
                                prop="createTime"
                                label="周期"
                                width="150">
                            </el-table-column>
                            <el-table-column
                                prop="createTime"
                                label="订购时间"
                                width="150">
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </el-drawer>

    </el-container>
</template>

<script>
import Api from '../../api/index'
import * as echarts from 'echarts'

// active test/active/inactive/suspend/cancel
const STATUSOPT = [
        { value: -1, label: "all" },
        { value: 0, label: "active test" },
        { value: 2, label: "inactive" },
        { value: 3, label: "active" },
        { value: 4, label: "suspend" },
        { value: 6, label: "cancel" }
    ];

export default {
  name: 'gm_sim_manage',
  data() {
    return {
        status_options: STATUSOPT,
        pkg_options: [],
        activetime: null,
        formQuery: {
            hold_id: 0,
            pkg_id: 0,
            key: '',
            iccid: "",
            msisdn: "",
            batch_field: '',
            batch_iccid: [],
            status: -1,
            active_begin: null,
            active_end: null,
            page_index: 1,
            page_size: 20,
            include_children: true
        },
        pkg_text: "请选择",
        displayHTreeVisible: true,
        holdTreeData: [],
        defaultProps: {
            children: 'children',
            label: 'label'
        },
        selectHoldId: 0,
        selectedHoldName: "",
        tableData: [],
        tableViewHeight: 600,
        loadingTableData: false,
        multipleSelection: [],
        pagging: {
            records_total: 3,
            pager_count: 5,
            pager_size: 20,
            current_page: 1
        },
        drawer: false,
        direction: 'rtl',  // Drawer 抽屉: 从右往左开
        drActiveName: 'detail',
        simCardDetailForm: {
            sim_id: 0,
            iccid: "",
            sim: "",
            imsi: "",
            package: "",
            quiet_period: "",
            status: "",
            active_time: "",
            expired_time: "",
            month_usage: 0,
            amount_usage: 0,
            main_ip: "",
            apn: "",
            imeiBindStatus: "",
            country: "",
            operator_locate: ""
        },
        monthlyUsageTable: [],
        sessionUsageTable: []
    }
  },
  methods: {
    handleNodeClick: function(data) {
      this.selectHoldId = data.id;
      this.selectedHoldName = data.label;
      this.search();
    },
    collapseHTree: function() {
      if(this.displayHTreeVisible) {
        this.displayHTreeVisible = false;
      } else {
        this.displayHTreeVisible = true;
      }
    },
    handleDrTabClick: function(tab, event) {
      console.log(tab.name);
      if(tab.name == "last3month_usage") {
        this.loadUsageByThreeMonth(this.simCardDetailForm.sim_id);
      } else if(tab.name == "session") {

      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.pagging.current_page = val;
      this.search();
    },
    handleFilterPkg: function() {
        this.pagging.current_page = 1;
        this.search();
    },
    handleChangeStatusSel: function() {
        this.pagging.current_page = 1;
        this.search();
    },
    submitSearch: function() {
        this.pagging.current_page = 1;
        this.search();
    },
    loadHoldTree: function(callback) {
      Api.GetHoldTree({}).then(res => {
        if(!res)
          return;

        if(res.code !== 200)
          return;

        this.holdTreeData = res.data;

        // 初始化选中的用户id
        this.selectHoldId = this.holdTreeData[0].id;
        this.selectedHoldName = this.holdTreeData[0].label;
        if(callback) callback();
      });
    },
    loadPkgOptions: function() {
        this.pkg_options = [];
        this.pkg_options.push({
            value: 0,
            label: "全部"
        });
        Api.OperatorPkgOptions({ operator_type : 5 }).then(res => {
            if(res.code === 200 && res.data) {
                res.data.forEach(element => {
                   this.pkg_options.push({
                        value: element.package_id,
                        label: element.package_name
                   }); 
                });
            }
        });
    },
    search: function() {
        this.loadingTableData = true;
        this.formQuery.hold_id = this.selectHoldId;
        if(this.formQuery.status === 0)
            this.formQuery.status = null;
        if(this.activetime) {
            this.formQuery.active_begin = this.activetime[0];
            this.formQuery.active_end = this.activetime[1];
        }
        this.formQuery.page_index = this.pagging.current_page;
        this.formQuery.page_size = this.pagging.pager_size;
        this.tableData = [];
        Api.GMSimsList(this.formQuery).then(res => {
            this.loadingTableData = false;
            if(!res)
                return;
            if(res.code === 200 && res.data) {
                this.pagging.records_total = res.total;
                this.tableData = res.data;
            } else {
                this.$message.info("暂无数据");
            }
        }).catch(err => {
            this.$message.error('错了哦，接口出错！' + err);
            this.loadingTableData = false;
        });
    },
    insyncCardInfo: function() {
        // 同步多张卡
        var simid_arr = [];
        this.multipleSelection.forEach(item => {
            simid_arr.push(item.sim_id);
        });
        if(simid_arr.length === 0) {
            this.$message.error('请选择卡！');
            return;
        }
        var argdata = {
            sim_ids: simid_arr
        };
        Api.GMInsyncMultipleCards(argdata).then(res => {
            if(res && res.code === 200) {
                this.$message({
                    message: '同步成功！',
                    type: 'success'
                });
                this.search();
            } else {
                this.$message.error(`提交失败！${res ? res.msg : ''}`);
            }
        });
    },
    removeCard: function(id) {
        var masters = [];
        if(id == 0) {
            if(this.multipleSelection.length > 0) {
            this.multipleSelection.forEach(s => {
                masters.push(s.sim_id);
            });
            } else {
            this.$message({
                message: '请选择卡',
                type: 'warning'
            });
            return;
            }
        } else {
            masters.push(id);
        }
        this.$confirm('此操作将删除该卡信息, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            var argdata = {
                sim_ids: masters
            };
            Api.RemoveSim(argdata).then(res => {
                if(res.code === 200) {
                    this.$message({
                        message: '已删除！',
                        type: 'success'
                    });
                    this.search();
                } else {
                    this.$message({
                        message: '删除失败！',
                        type: 'warning'
                    });
                }
            });
        });
    },
    openCardDetailDrawer: function(row, column, event) {
        if(column.label === "操作")
            return;
        this.drawer = true;
        this.drActiveName = 'detail';

        Api.GMSimDetail({ sim_id: row.sim_id }).then(res => {
            if(res && res.code === 200 && res.data) {
                var baseInfo = res.data.base_info;
                this.simCardDetailForm.sim_id = baseInfo.sim_id;
                this.simCardDetailForm.iccid = baseInfo.iccid;
                this.simCardDetailForm.sim = baseInfo.sim;
                this.simCardDetailForm.package = baseInfo.package_name;
                this.simCardDetailForm.quiet_period = baseInfo.quiet_period ?? "--";
                this.simCardDetailForm.status = baseInfo.status;
                this.simCardDetailForm.active_time = baseInfo.active_time;
                this.simCardDetailForm.expired_time = baseInfo.expire_time;
                this.simCardDetailForm.amount_usage = baseInfo.amount_usage;
                this.simCardDetailForm.month_usage = baseInfo.month_usage;
                this.simCardDetailForm.main_ip = baseInfo.main_ip;
                this.simCardDetailForm.apn = baseInfo.apn;
                this.simCardDetailForm.imeiBindStatus = baseInfo.imeiBindStatus;
                this.simCardDetailForm.country = baseInfo.country;
                this.simCardDetailForm.operator_locate = baseInfo.operator_locate;

                let surplus = this.simCardDetailForm.amount_usage - this.simCardDetailForm.month_usage;
                this.$nextTick(() => {
                    this.loadUsageCharts(this.simCardDetailForm.month_usage, surplus);
                });
            } else {
                console.log(`获取sim卡资料没返回数据${res ? res.msg : ''}`);
            }
        });
    },
    loadUsageByThreeMonth: function(sim_id) {
        // 加载卡近三个月使用流量
        this.monthlyUsageTable = [];
        Api.GMUsageByThreeMonth({ sim_id: sim_id }).then(res => {
            if(res && res.code === 200 && res.data) {
                this.monthlyUsageTable = res.data;
            } else {
                console.log(`获取sim卡资料没返回数据${res ? res.msg : ''}`);
            }
        });
    },
    loadUsageCharts: function(usage, surplus) {
      // 通过 ref 获取 DOM 元素
      const chartDom = this.$refs.pieChart;
      // 初始化 ECharts 实例
      this.chartInstance = echarts.init(chartDom);
      // 4. 配置饼图的 option
      const option = {
        title: {
          text: '月使用流量',
          left: 'center' // 标题居中
        },
        tooltip: {
          trigger: 'item', // 触发类型：数据项图形触发
          formatter: '{a} <br/>{b} : {c} ({d}%)' // 提示框内容格式
        },
        legend: {
          orient: 'vertical', // 图例垂直排列
          left: 'left', // 图例靠左
          data: ['已使用流量', '剩余流量']
        },
        series: [
          {
            name: '月使用流量',
            type: 'pie', // 图表类型：饼图
            radius: '50%', // 饼图半径
            center: ['50%', '60%'], // 饼图位置（水平居中，垂直偏下）
            data: [
              { value: usage, name: '已使用流量' },
              { value: surplus, name: '剩余流量' }
            ],
            label: {
              show: true,
              formatter: '{b}\n{c} MB',  // name 换行显示数值
              fontSize: 12,
              color: '#333'
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
      // 5. 使用刚指定的配置项显示图表
      this.chartInstance.setOption(option);
    },
  },
  mounted() {
    var h = document.body.clientHeight - 280;
    var h2 = document.body.clientHeight - 280;
    this.$nextTick(() => {
      const table = this.$refs.getTableInstance;
      if (table) {
        // 使用原生JavaScript设置高度
        table.$el.style.height = h + 'px';
        // 或者使用Vue.set来响应式地更新样式
        // this.$set(table.$el.style, 'height', '300px');
      }
      const tree = this.$refs.getTreeInstance;
      if(tree) {
        tree.$el.style.height = h2 + 'px';
      }
    });

    this.loadHoldTree(this.search);
    this.loadPkgOptions();
  }
}
</script>

<style scoped>
.queryfm-head {
    padding-top: 10px;
    padding-bottom: 10px;
}
.dr-container {
  padding-left: 10px;
}
.dr-card-detail {
  padding: 10px;
}
.dr-card-label {
  padding-top: 12px;
  padding-bottom: 5px;
  color: #999999;
}
</style>